// AutoGenerated
export enum EnmSesGrupTip {
    "Ana Ses Grubu" = 1,
    "Alt Ses Grubu" = 2,
    "Diğer" = 3,
    "Üst Ses Grubu" = 4,
    "Alt Divizi Ses Grubu" = 5,
}